"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusRing = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactAria = require("react-aria");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function getFocusRingDisplay(isFlex) {
  if (isFlex) {
    return (0, _styledComponents.css)(["display:flex;flex-direction:column;"]);
  }
  return (0, _styledComponents.css)(["display:inline-block;"]);
}
var focusRingCss = function focusRingCss() {
  return (0, _styledComponents.css)(["border-radius:", ";outline:2px solid ", ";outline-offset:-2px;"], function (props) {
    return props.theme.sys.size.borderradius.focusring;
  }, function (props) {
    return props.theme.sys.color.border.focusring;
  });
};
var FocusRingStyle = _styledComponents.default.div.withConfig({
  displayName: "FocusRing__FocusRingStyle",
  componentId: "sc-1r05kfk-0"
})([".focus-ring{", "}> :focus{", "}", ""], function () {
  return focusRingCss();
}, function (props) {
  return props.mouseFocus ? focusRingCss() : '';
}, function (props) {
  return getFocusRingDisplay(props.isFlex);
});
var FocusRing = function FocusRing(_ref) {
  var children = _ref.children,
    _ref$isTextInput = _ref.isTextInput,
    isTextInput = _ref$isTextInput === void 0 ? false : _ref$isTextInput,
    _ref$mouseFocus = _ref.mouseFocus,
    mouseFocus = _ref$mouseFocus === void 0 ? false : _ref$mouseFocus,
    _ref$isFlex = _ref.isFlex,
    isFlex = _ref$isFlex === void 0 ? false : _ref$isFlex;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FocusRingStyle, {
    mouseFocus: mouseFocus,
    isFlex: isFlex,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAria.FocusRing, {
      isTextInput: isTextInput,
      focusRingClass: "focus-ring",
      children: children
    })
  });
};
exports.FocusRing = FocusRing;